<template>
  <div v-if="convo.meta.references.length || isEditable" class="w3-theme-light">
    <references 
    v-bind:label="'References'"
    v-bind:references="convo.meta.references" 
    v-bind:isEditable="isEditable"
    v-bind:model="convo"
    v-on:addReference="addConvoReference()"
    v-on:removeReference="removeConvoReference($event)"
    />
  </div>
</template>

<script>
  import ConvoReferences from "./ConvoReferences.ts";

  export default ConvoReferences;
</script>
